import React, { useContext } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { ScrollContext } from "components/store/source";
import { Column } from "components/ui/source";

import styles from "./Navbar.module.scss";

function StickySearchBar({ searchInput, children }) {
  const { searchWidgetIntersectRatio } = useContext(ScrollContext);
  const isVisible = searchWidgetIntersectRatio < 0.1;

  return (
    <div
      className={classnames(
        styles.search_container,
        isVisible && styles.visible,
      )}
    >
      <div className={styles.search}>
        {searchInput}
        <Column size="third" hasBottomGutter={false}>
          {children}
        </Column>
      </div>
    </div>
  );
}

StickySearchBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  searchInput: PropTypes.node,
};

StickySearchBar.defaultProps = {
  children: null,
  searchInput: null,
};

export default StickySearchBar;
